import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch } from 'vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressBar',
  props: {
    percentage: {
      required: true,
      type: Number,
    },
    actualValue: Number,
    showBadge: Boolean,
    slimWithNoBorder: Boolean,
  },
  emits: ['badge-left-width'],
  setup(__props, { emit }) {

const props = __props;

  
  

  const badge = ref(null as HTMLDivElement | null)
  const leftWidth = ref(20)
  const timerId = ref(0)

  const setLeftWidth = () => {
    timerId.value = window.setTimeout(() => {
      if (badge.value) {
        leftWidth.value = Math.round(badge.value.clientWidth / 2)
        emit('badge-left-width', leftWidth.value)
      }
    }, 300)
  }

  onMounted(() => {
    setLeftWidth()
  })

  watch(
    () => props.actualValue,
    () => {
      setLeftWidth()
    },
  )

return { __sfc: true,props, emit, badge, leftWidth, timerId, setLeftWidth, onMounted, ref, watch }
}

})